import { IntegrationCampaign } from '@aibees/elephant/types/integration';
import { useMemo } from 'react';
import { IntegrationCampaignOption } from './types';

export function useConvertDataToDropDownOption(items?: IntegrationCampaign[]) {
  return useMemo(
    () =>
      (items?.map((item) => ({
        name: item.name,
        id: item.id,
        value: item.id,
      })) || []) as IntegrationCampaignOption[],
    [items]
  );
}
